/* "On this page" list: builds links from the headings in a long page body.
   Without JS the list stays hidden and the page reads normally. */
(() => {
  const slug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';

  document.querySelectorAll('[data-contents]').forEach((root) => {
    const source = root.querySelector('[data-contents-source]');
    const nav = root.querySelector('[data-contents-nav]');
    const list = nav && nav.querySelector('ol');
    if (!source || !list) return;

    const all = [...source.querySelectorAll('h2, h3, h4')].filter((h) => h.textContent.trim());
    if (all.length < 3) return;
    // Only the top level present, so a body that uses h4 for its sections still works.
    const top = Math.min(...all.map((h) => Number(h.tagName[1])));
    const heads = all.filter((h) => Number(h.tagName[1]) === top);
    if (heads.length < 3) return;

    const used = new Set(Array.from(document.querySelectorAll('[id]'), (el) => el.id));
    const links = heads.map((h) => {
      let id = h.id;
      if (!id) {
        const base = slug(h.textContent);
        id = base;
        for (let i = 2; used.has(id); i++) id = `${base}-${i}`;
        h.id = id;
        used.add(id);
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    nav.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    const byId = new Map(links.map((a) => [a.hash.slice(1), a]));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((a) => a.removeAttribute('aria-current'));
        byId.get(entry.target.id)?.setAttribute('aria-current', 'location');
      });
    }, { rootMargin: '0px 0px -70% 0px' });
    heads.forEach((h) => observer.observe(h));
  });
})();
